/* AVRA — FIX 14c. Escape closes the nav drawer, and focus goes home.

   THE BUG: open the menu, press Escape, nothing happens — the drawer keeps
   the class "navdrawer open". A keyboard user who opens the menu has no way
   out of it without tabbing through every link inside it.

   THE SECOND HALF: closing an overlay is only half the job. Focus has to go
   back to the control that opened it, or the user is dropped at the top of
   the document and has to tab through the whole page again.

   TWO THINGS THIS HAD TO WORK AROUND, both found by testing rather than
   assuming:

   1. .burger is display:none above the mobile breakpoint, and .focus() on a
      display:none element is a silent no-op. So the trigger is not
      hardcoded — this records whatever control was actually pressed, and
      checks it is still rendered before focusing it.

   2. The theme's own close handler moves focus to the skip-to-content link,
      and it does so AFTER the next animation frame. Restoring focus once,
      immediately, loses the race. So focus is re-asserted at three points
      and only while focus is still somewhere nobody chose — <body>, the
      skip link, or inside the drawer that just closed. If the visitor has
      deliberately moved focus in the meantime, this leaves it alone.

   Self-contained. Delete this file and its <script> tag in layout/theme.liquid
   and the theme behaves exactly as it did before. */

(function () {
  'use strict';

  var lastTrigger = null;

  function focusable(el) {
    return !!(el && el.isConnected && typeof el.focus === 'function' &&
              el.getClientRects().length);          /* rendered, so focusable */
  }

  function remember(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var ctl = t.closest('button, [role="button"], a[href], summary');
    if (ctl) lastTrigger = ctl;
  }

  /* Focus was dumped rather than deliberately moved. */
  function focusIsStranded(drawer) {
    var a = document.activeElement;
    if (!a || a === document.body) return true;
    if (a.classList && a.classList.contains('skip-to-content-link')) return true;
    if (drawer && drawer.contains(a)) return true;
    return false;
  }

  function restoreFocus(target, drawer) {
    if (!focusable(target)) return;
    var attempt = function () {
      if (!focusIsStranded(drawer)) return;         /* visitor took over */
      if (!focusable(target)) return;               /* went away meanwhile */
      try { target.focus(); } catch (err) {}
    };
    requestAnimationFrame(attempt);
    setTimeout(attempt, 150);
    setTimeout(attempt, 400);
  }

  function wireEscape() {
    /* Capture phase, so we still see the control even if its own handler
       stops the event from bubbling any further. */
    document.addEventListener('pointerdown', remember, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') remember(e);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;

      var drawer = document.querySelector('.navdrawer.open');
      if (!drawer) return;

      var trigger = lastTrigger;
      if (!focusable(trigger) || drawer.contains(trigger)) {
        trigger = document.querySelector('.burger');
      }

      /* Prefer the theme's own close button so its teardown runs too —
         scroll lock, aria state, whatever else it does on the way out. */
      var close = drawer.querySelector('[data-drawer-close]');
      if (close) { close.click(); } else { drawer.classList.remove('open'); }

      restoreFocus(trigger, drawer);
      e.preventDefault();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireEscape);
  } else {
    wireEscape();
  }
})();
